import { Tooltip } from "antd";
import moment from "moment";
import { removerDuplicadosPorOperacao } from "../../../ModalOrdemServicoMatriz/utils";
import { limitarCaracteres } from "../../../ModalPlanejamentoOperacoes/utils";
import useStore from "../../hooks/useStore";
import useModalOrdemServicoMatriz from "../../../OrdemServico/hooks/useModalOrdemServicoMatriz";
import {
  MatrizScrollContainer,
  MatrizTable,
  TableHeaderCell,
  OperationHeader,
  OperationHeaderContent,
  OperationHeaderTitle,
  SelectAllColumnBtn,
  TableBodyCell,
  OperationCell,
  OperationCard,
  OperationCardDate,
  OperationCardInputCheck,
  OperationCardSequence,
  OperationCardStatus,
  EmptyCell,
} from "../../styles";
import { IconOSNew } from "../../../MapInfoSemaforo/IconsMap";
import { IoPricetag } from "react-icons/io5";

interface OperacoesTableProps {
  operacoes: any[];
  action?: string;
}

function OperacoesTable({ operacoes, action }: OperacoesTableProps) {

  const {
    planoOperacionalOperacaoTalhaoIds,
    setPlanoOperacionalOperacaoTalhaoIds,
  } = useStore();

  const {
    hiddenBlockeds,
    hiddenCompleteds,
  } = useModalOrdemServicoMatriz();

  const operationHeaderList = removerDuplicadosPorOperacao(operacoes);
  const [header] = operationHeaderList;

  function handleSelect(checked: boolean, talhao: any) {
    const id = talhao.planoOperacionalOperacaoTalhaoId;
    if (checked) {
      setPlanoOperacionalOperacaoTalhaoIds(id);
      return;
    }
    setPlanoOperacionalOperacaoTalhaoIds(planoOperacionalOperacaoTalhaoIds.filter(p => p !== id));
  }

  function handleSelectAllFromColumn(checked: boolean, index: number) {
    const talhoes = operacoes.map((t: any) => t.planoOperacionalOperacaoTalhao[index]);
    const talhoesFiltered = talhoes.filter((t: any) => !t.bloqueado);
    const ids = talhoesFiltered.map((t: any) => t?.planoOperacionalOperacaoTalhaoId);
    if (checked) {
      const arr = [...planoOperacionalOperacaoTalhaoIds, ...ids];
      setPlanoOperacionalOperacaoTalhaoIds(arr);
      return;
    }
    setPlanoOperacionalOperacaoTalhaoIds(planoOperacionalOperacaoTalhaoIds.filter(o => !ids.includes(o)));
  }

  function handleCheckColumnBlock(index: number) {
    const talhoes = operacoes.map((t: any) => t.planoOperacionalOperacaoTalhao[index]);
    const result = talhoes.some((t: any) => !t.bloqueado);
    return !result;
  }

  function getStatusText(status: string) {
    if (status === "AguardandoAtivacao") {
      return "Aguardando Ativação";
    }
    if (status === "ExecutadaParcialmente") {
      return "Executada Parcialmente";
    }
    return status;
  }

  function getStatusColor(status: string) {
    if (status === "Executada") {
      return "#4caf50";
    }
    if (status === "Atrasada") {
      return "#f44336";
    }
    if (status === "ExecutadaParcialmente") {
      return "#ff9800";
    }
    return "#2196f3";
  }

  return (
    <MatrizScrollContainer>
      <MatrizTable>
        <thead>
          <tr>
            <TableHeaderCell>Talhão</TableHeaderCell>
            {header?.planoOperacionalOperacaoTalhao?.map((value, index) => {
              const { operacaoClasse } = value;

              return (
                <OperationHeader key={index}>
                  <OperationHeaderContent>
                    <Tooltip title={operacaoClasse}>
                      <OperationHeaderTitle title={operacaoClasse}>{limitarCaracteres(operacaoClasse, 23)}</OperationHeaderTitle>
                    </Tooltip>
                    <SelectAllColumnBtn>
                      <input
                        type="checkbox"
                        disabled={handleCheckColumnBlock(index)}
                        onChange={(e) => handleSelectAllFromColumn(e.target.checked, index)}
                      />
                      Todos
                    </SelectAllColumnBtn>
                  </OperationHeaderContent>
                </OperationHeader>
              );
            })}
          </tr>
        </thead>
        <tbody>
          {operacoes?.sort((a, b) => Number(a.codigo) - Number(b.codigo))?.map((operacao, index) => (
            <tr key={index}>
              <TableBodyCell>
                <div>T{operacao?.codigo}</div>
                <div>{operacao?.areaPlantadaHa} ha</div>
              </TableBodyCell>
              {operacao.planoOperacionalOperacaoTalhao?.map((talhao: any, index: number) => {
                const isPlaceholder = talhao.isPlaceholder;
                const status = talhao.status;
                const bloqueado = talhao.bloqueado;
                const executado = talhao?.areaDisponivelPorcentagem <= 0;
                const possuiVinculo = talhao?.ordensServico?.length > 0;
                const data = talhao?.periodoDataInicio && talhao?.periodoDataFim ? `${moment.utc(talhao?.periodoDataInicio).format("DD/MM/YYYY")} à ${moment.utc(talhao?.periodoDataFim).format("DD/MM/YYYY")}` : moment.utc(talhao?.dataProgramada).format("DD/MM/YYYY");
                const dataExecucao = talhao?.dataExecucao ? moment.utc(talhao?.dataExecucao).format("DD/MM/YYYY") : null;
                const nameDate = talhao?.status === "ExecutadaParcialmente" ? "Data Exec. Parcial:" : "Data Executada:";
                const dataSemAno = talhao?.periodoDataInicio && talhao?.periodoDataFim ? `${moment.utc(talhao?.periodoDataInicio).format("DD/MM")} à ${moment.utc(talhao?.periodoDataFim).format("DD/MM")}` : moment.utc(talhao?.dataProgramada).format("DD/MM");
                const colorStatus = getStatusColor(status);
                const showTooltipAndIcon = action === "justificar" && status?.includes("Atrasada") && talhao?.possuiJustificativaAtraso;

                return (
                  <Tooltip overlayStyle={{ maxWidth: 440 }} title={
                    <>
                      <p>{talhao?.operacaoCodigo} - {talhao?.operacao}</p>
                      <p>Plano: {talhao?.planoOperacional ?? "-"}</p>
                      <p>Data Programada: {data}</p>
                      {possuiVinculo && dataExecucao && <p>{nameDate} {dataExecucao}</p>}
                      {possuiVinculo && <p>O.S.: {talhao?.ordensServico?.join(", ")}</p>}
                      <p>Área Disponível: {talhao?.areaDisponivelPorcentagem?.toFixed(2)}%: {talhao.areaDisponivelHa?.toFixed(2)}ha</p>
                      {showTooltipAndIcon && <p>ATRASO JUSTIFICADO</p>}
                    </>
                  }>
                    <OperationCell key={index}>
                      {(hiddenCompleteds && status?.includes("Executada")) || (hiddenBlockeds && bloqueado && !executado) || isPlaceholder ? (
                        <EmptyCell>-</EmptyCell>
                      ) : (
                        <OperationCard>
                          {possuiVinculo && <IconOSNew width={16} height={18} heightSpec={1} style={{ position: 'absolute', left: 10, top: 10 }} />}
                          {showTooltipAndIcon && <IoPricetag color="#f44336" size={20} style={{ position: 'absolute', left: 7, top: 50 }} />}
                          {((action === "justificar" && status === "Atrasada") || (!executado)) && (
                            <OperationCardInputCheck
                              type="checkbox"
                              disabled={bloqueado}
                              onChange={(e) => handleSelect(e.target.checked, talhao)}
                              checked={planoOperacionalOperacaoTalhaoIds.includes(talhao.planoOperacionalOperacaoTalhaoId)}
                            />
                          )}
                          <OperationCardSequence>{talhao.index}ª</OperationCardSequence>
                          <OperationCardDate>{dataSemAno}</OperationCardDate>
                          <OperationCardStatus backgroundColor={colorStatus}>{getStatusText(status)}</OperationCardStatus>
                        </OperationCard>
                      )}
                    </OperationCell>
                  </Tooltip>
                );
              })}
            </tr>
          ))}
        </tbody>
      </MatrizTable>
    </MatrizScrollContainer>
  );
}

export default OperacoesTable
